import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-grid-range-cell',
    template: `
        @if (!params.excluded) {
          <div>
            @if (!params.inRange && !params.aboveRange && showIcon) {
              <div class="icon icon-red-down"></div>
            }
            @if (!params.inRange && params.aboveRange && showIcon) {
              <div class="icon icon-red-up"></div>
            }
            @if (params.inRange && showIcon) {
              <div class="icon icon-green-tick"></div>
            }
            @if (!params.inRange && !params.aboveRange && showIconWithLabel) {
              <div class="icon icon-arrow-down center" tooltip tooltipTitle="Below" [tooltipRequiresTruncation]="true">Below</div>
            }
            @if (!params.inRange && params.aboveRange && showIconWithLabel) {
              <div class="icon icon-arrow-up center" tooltip tooltipTitle="Above" [tooltipRequiresTruncation]="true">Above</div>
            }
            @if (params.inRange && showIconWithLabel) {
              <div class="icon icon-green-inline-tick center" tooltip tooltipTitle="In range" [tooltipRequiresTruncation]="true">In range</div>
            }
            @if (params.inRange && !showIconWithLabel) {
              <div class="icon icon-green-inline-tick center" tooltip tooltipTitle="{{value}}{{append}}" [tooltipRequiresTruncation]="true">{{value}}{{append}}</div>
            }
            @if (!params.inRange && !showIconWithLabel) {
              <div class="icon icon-warning center" tooltip tooltipTitle="{{value}}{{append}}" [tooltipRequiresTruncation]="true">{{value}}{{append}}</div>
            }
          </div>
        }
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: `
        .icon-arrow-down {
            background-image: url("/assets/images/arrow-down.png");
            background-repeat: no-repeat;
            background-position-y: center;
            background-position: right;
            cursor: default;
            padding: 0 25px 0 25px;
        }

        .icon-arrow-up {
            background-image: url("/assets/images/arrow-up.png");
            background-repeat: no-repeat;
            background-position-y: center;
            cursor: default;
            padding: 0 25px 0 25px;
        }

        .icon-green-inline-tick {
            background-image: url("/assets/images/check.png");
            background-repeat: no-repeat;
            background-position-y: center;
            cursor: default;
            padding: 0 25px 0 25px;
        }

        .icon-warning {
            background-image: url("/assets/images/icon_warning.png");
            background-repeat: no-repeat;
            background-position-y: center;
            cursor: default;
            padding: 0 25px 0 25px;
        }
    `
})
export class RangeCellComponent implements AgRendererComponent {
    params: any;
    showIcon: boolean;
    showIconWithLabel: boolean;
    value: number;
    append: string;

    constructor() {}

    agInit(params: any) {
        this.params = params;
        this.showIconWithLabel = (typeof this.params.showIconWithLabel !== "undefined" && typeof this.params.value !== "string") ? this.params.showIconWithLabel : false;

        if(!this.showIconWithLabel && typeof this.params.value !== "string") {
        this.showIcon = (typeof this.params.showIcon !== "undefined") ? this.params.showIcon : isNaN(this.params.value);
        } else {
            this.showIcon = false;
        }

        this.value = (!this.showIcon && !this.showIconWithLabel) && this.params.absoluteValue ? Math.abs(this.params.value) : this.params.value;
        this.append = (this.value > 1) ? " securities" : (this.value == 1) ? " security" : "";
    }

    refresh(): boolean {
        return true;
    }
}
